export enum Status {
  Active = 'active',
  Disabled = 'disabled',
  Pending = 'pending',
  External = 'external',
  None = '',
}
